
import { useState } from "react";

import ActionPanel from "./ActionPanel";
import ListElement from "./ListElement";
import MultiProperties from "./MultiProperties";

// components
import { LabelProperties } from "../primitive/Label";
import { BoxProperties } from "../primitive/Box";
import { InputProperties } from "../primitive/Input";
import { ButtonProperties } from "../primitive/Button";
import { RadioProperties } from "../primitive/Radio";
import { CheckProperties } from "../primitive/Check";
import { ListProperties } from "../primitive/List";
import { DropProperties } from "../primitive/Drop";
import { ImageProperties } from "../primitive/Image";

import { SignatureProperties } from "../intermediate/Signature";
import { InputTableProperties } from "../intermediate/InputTable";
import { SnapshotProperties } from "../intermediate/Snapshot";

import { Card } from 'antd';



export default function ControlPanel({
    comps,
    setComps,
    sel,
    setSel,
    multiSel,
    setMultiSel,
    hov,
    setHov,
    pages,
    setPages,
    currentPage,
    setCurrentPage,
    vars,
    setVars,
    externals,
    setExternals,
    parent,
    setParent,
    name,
    setName,
    dbId,
    setDbId,
    pageId,
    onFormSaveCallback,
    layout,
    setLayout,
    creationIndex,
    setCreationIndex,
    scriptExecutionTime, 
    setScriptExecutionTime,
    scriptExecutionMode, 
    setScriptExecutionMode
}) {

    // Drag-to-reorder state for the Elements list.
    const [dragId, setDragId] = useState(null);
    const [dragOverId, setDragOverId] = useState(null);

    const moveElement = (from, to) => {
        if (from === null || to === null || from === to) return;
        let new_comps = [...comps];
        const [moved] = new_comps.splice(from, 1);
        new_comps.splice(to, 0, moved);
        setComps(new_comps);
        // Indices have shifted, so drop any index-based selection.
        setSel(-1);
        if (setMultiSel) setMultiSel([]);
    };

    let properties = <></>;
    if (multiSel && multiSel.length > 1) {
        properties = <MultiProperties comps={comps} setComps={setComps}
            multiSel={multiSel} setMultiSel={setMultiSel} setSel={setSel}
            vars={vars} setVars={setVars} externals={externals} setExternals={setExternals}
            creationIndex={creationIndex} setCreationIndex={setCreationIndex} />;
    } else if (sel === -1) {
        properties = <div className="create-form-empty">
            <p className="cfe-title">No element selected</p>
            <p className="cfe-sub">Select an element on the page to edit its properties.</p>
        </div>
    } else {
        if (comps[sel].type === 'primitive/Label') {
            properties = <LabelProperties id={sel} comps={comps} setter={setComps} setSel={setSel}
                vars={vars} setVars={setVars} externals={externals} setExternals={setExternals}
                creationIndex={creationIndex} setCreationIndex={setCreationIndex} />;
        } else if (comps[sel].type === 'primitive/Box') {
            properties = <BoxProperties id={sel} comps={comps} setter={setComps} setSel={setSel}
                vars={vars} setVars={setVars} externals={externals} setExternals={setExternals}
                creationIndex={creationIndex} setCreationIndex={setCreationIndex} />;
        } else if (comps[sel].type === 'primitive/Input') {
            properties = <InputProperties id={sel} comps={comps} setter={setComps} setSel={setSel}
                vars={vars} setVars={setVars} externals={externals} setExternals={setExternals}
                creationIndex={creationIndex} setCreationIndex={setCreationIndex} />;
        } else if (comps[sel].type === 'primitive/Button') {
            properties = <ButtonProperties id={sel} comps={comps} setter={setComps} setSel={setSel}
                vars={vars} setVars={setVars} externals={externals} setExternals={setExternals}
                creationIndex={creationIndex} setCreationIndex={setCreationIndex} />;
        } else if (comps[sel].type === 'primitive/Radio') {
            properties = <RadioProperties id={sel} comps={comps} setter={setComps} setSel={setSel}
                vars={vars} setVars={setVars} externals={externals} setExternals={setExternals}
                creationIndex={creationIndex} setCreationIndex={setCreationIndex} />;
        } else if (comps[sel].type === 'primitive/Check') {
            properties = <CheckProperties id={sel} comps={comps} setter={setComps} setSel={setSel}
                vars={vars} setVars={setVars} externals={externals} setExternals={setExternals}
                creationIndex={creationIndex} setCreationIndex={setCreationIndex} />;
        } else if (comps[sel].type === 'primitive/List') {
            properties = <ListProperties id={sel} comps={comps} setter={setComps} setSel={setSel}
                vars={vars} setVars={setVars} externals={externals} setExternals={setExternals}
                creationIndex={creationIndex} setCreationIndex={setCreationIndex} />;
        } else if (comps[sel].type === 'primitive/Drop') {
            properties = <DropProperties id={sel} comps={comps} setter={setComps} setSel={setSel}
                vars={vars} setVars={setVars} externals={externals} setExternals={setExternals}
                creationIndex={creationIndex} setCreationIndex={setCreationIndex} />;
        } else if (comps[sel].type === 'primitive/Image') {
            properties = <ImageProperties id={sel} comps={comps} setter={setComps} setSel={setSel}
                vars={vars} setVars={setVars} externals={externals} setExternals={setExternals}
                creationIndex={creationIndex} setCreationIndex={setCreationIndex} />;
        } else if (comps[sel].type === 'intermediate/Signature') {
            properties = <SignatureProperties id={sel} comps={comps} setter={setComps} setSel={setSel}
                vars={vars} setVars={setVars} externals={externals} setExternals={setExternals}
                creationIndex={creationIndex} setCreationIndex={setCreationIndex} />;
        } else if (comps[sel].type === 'intermediate/InputTable') {
            properties = <InputTableProperties id={sel} comps={comps} setter={setComps} setSel={setSel}
                vars={vars} setVars={setVars} externals={externals} setExternals={setExternals}
                creationIndex={creationIndex} setCreationIndex={setCreationIndex} />;
        } else if (comps[sel].type === 'intermediate/Snapshot') {
            properties = <SnapshotProperties id={sel} comps={comps} setter={setComps} setSel={setSel}
                vars={vars} setVars={setVars} externals={externals} setExternals={setExternals}
                creationIndex={creationIndex} setCreationIndex={setCreationIndex} />;
        }
    }

    let elements = [];
    for (let k = 0; k < comps.length; ++k) {
        if (comps[k].page === currentPage) {
            elements.push(
                <ListElement id={k} comps={comps} setComps={setComps} sel={sel} setSel={setSel}
                    hov={hov} setHov={setHov}
                    dragId={dragId} setDragId={setDragId}
                    dragOverId={dragOverId} setDragOverId={setDragOverId}
                    moveElement={moveElement} />
            );
        }
    } if (elements.length === 0) {
        elements = <div className="create-form-empty">
            <p className="cfe-title">No elements yet</p>
            <p className="cfe-sub">Use the + button below to add your first element.</p>
        </div>;
    }

    return (
        <div className="form-control-box">
            <Card className="card1" title="Properties" bordered={false}>
                <div style={{ padding: '12px 14px' }}>
                    {properties}
                </div>
            </Card>

            <Card className="card2" title="Elements" bordered={false}>
                <div>
                    {elements}
                </div>
            </Card>

            <ActionPanel
                setSelectedEl={setSel}
                comps={comps} setComps={setComps} page={currentPage} setPage={setCurrentPage}
                pages={pages} setPages={setPages} vars={vars} setVars={setVars}
                externals={externals} setExternals={setExternals} parent={parent} setParent={setParent}
                name={name} setName={setName} dbId={dbId} setDbId={setDbId} pageId={pageId} onFormSaveCallback={onFormSaveCallback} 
                layout={layout} setLayout={setLayout} creationIndex={creationIndex} setCreationIndex={setCreationIndex}
                scriptExecutionTime={scriptExecutionTime} 
                setScriptExecutionTime={setScriptExecutionTime}
                scriptExecutionMode={scriptExecutionMode}
                setScriptExecutionMode={setScriptExecutionMode}
                     />
        </div>
    );

}